import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '../hooks/index.ts';
import { DemoNotice } from '../components/demo-notice.tsx';

export default function NotFoundPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('notFound.documentTitle'));

  return (
    <>
      {/* This route sits outside both shells (see app.tsx), so it needs the
          notice of its own — a mistyped URL is still a screen of the demo. */}
      <DemoNotice />
      <main data-testid="not-found" className="mx-auto max-w-xl px-4 py-24 text-center">
        <h1 className="text-2xl font-bold">{t('notFound.title')}</h1>
        <p className="mt-2 text-[color:var(--color-muted)]">{t('notFound.message')}</p>
        <Link to="/quotes" className="btn btn-primary mt-6 inline-flex">
          {t('notFound.goToQuotes')}
        </Link>
      </main>
    </>
  );
}
